import * as React from 'react';
import { OverlayViewF, OVERLAY_MOUSE_TARGET } from '@react-google-maps/api';

/** Half a DriverPin's dot, which sits on the point. */
const DOT_RADIUS = 18;

/**
 * A library pin held at a point on the map. Google's own Marker draws from
 * an icon and a colour string, so it cannot be a token-coloured component;
 * an overlay is ordinary HTML that moves with the map. The dashboard's live
 * map does the same.
 */
export function Pinned({
  lat,
  lng,
  anchor = 'centre',
  children,
}: {
  lat: number;
  lng: number;
  /** `dot` for a DriverPin, whose dot leads; `centre` for a label pin. */
  anchor?: 'dot' | 'centre';
  children: React.ReactNode;
}) {
  return (
    <OverlayViewF
      position={{ lat, lng }}
      mapPaneName={OVERLAY_MOUSE_TARGET}
      getPixelPositionOffset={(width, height) =>
        anchor === 'dot'
          ? { x: -DOT_RADIUS, y: -height / 2 }
          : { x: -width / 2, y: -height / 2 }
      }
    >
      {children}
    </OverlayViewF>
  );
}
